import { ASSIGNMENT_STATUS_LIST } from 'constants/backend'
import React from 'react'
import { Col, RowMargin } from 'components/UI/Grid'
import UniversalStaticSelectField from 'components/Form/Select/UniversalStaticSelectField'
import {
  Field,

  UniversalSearchField,
  CheckboxBordered
} from '../../../../components/Form'
import * as API from '../../../../constants/api'

export const fields = ['contract', 'client', 'branch', 'teamLeader', 'isBillable', 'all', 'status']
const AssignmentListFilterForm = () => {
  return (
    <>
      <RowMargin gutter={20}>
        <Col span={8}>
          <Field
            component={UniversalSearchField}
            name="contract"
            label="contract"
            itemText={['contractNumber']}
            api={API.CONTRACT_LIST}
          />
        </Col>
        <Col span={8}>
          <Field
            component={UniversalSearchField}
            name="client"
            label="client"
            api={API.CLIENT_LIST}
          />
        </Col>
        <Col span={8}>
          <Field
            component={UniversalSearchField}
            name="branch"
            label="Branch"
            api={API.BRANCH_LIST}
          />
        </Col>
      </RowMargin>
      <RowMargin gutter={20}>
        <Col span={8}>
          <Field
            component={UniversalSearchField}
            name="teamLeader"
            label="Team Leader"
            itemText={['fullName']}
            api={API.STAFF_LIST}
          />
        </Col>
        <Col span={8}>
          <Field
            component={UniversalStaticSelectField}
            name="status"
            label="Status"
            list={ASSIGNMENT_STATUS_LIST}
          />
        </Col>
        <Col span={8}>
          <Field
            name="isBillable"
            label={{ checkbox: 'Billable', field: 'Billing' }}
            component={CheckboxBordered}
            defaultValue={true}
            type="checkbox"
          />
        </Col>
        <Col span={8}>
          <Field
            name="all"
            label={{ field: 'Show all', checkbox: 'show all' }}
            component={CheckboxBordered}
            type="checkbox"
          />
        </Col>
      </RowMargin>
    </>
  )
}

export default AssignmentListFilterForm
